// src/components/transportations/Table/TransportationsTableColumns.jsx

const TransportationsTableColumns = [
    { id: "image", labelAr: "الصورة", labelEn: "Image", sortable: false },
    { id: "name_ar", labelAr: "الاسم (عربي)", labelEn: "Name (Arabic)", sortable: true },
    { id: "name_en", labelAr: "الاسم (إنجليزي)", labelEn: "Name (English)", sortable: true },
    { id: "capacity", labelAr: "السعة", labelEn: "Capacity", sortable: false },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default TransportationsTableColumns;
